import { fromJS } from "immutable";
/** @typedef { BLUR | BRIGHTNESS | CONTRAST | SATURATE | INVERT} FilterFunction */
/** @typedef { FilterFunction, label: string, default: number, min: string, max: string, units: string } BackdropFilterDefinition */

/** @type {"blur"} */
export const BLUR = "blur";
/** @type {"brightness"} */
export const BRIGHTNESS = "brightness";
/** @type {"contrast"} */
export const CONTRAST = "contrast";
/** @type {"saturate"} */
export const SATURATE = "saturate";
/** @type {"invert"} */
export const INVERT = "invert";

/** @type {Array<BackdropFilterDefinition>} */
const BACKDROP_FILTER_DEFINITIONS = [
  { id: BLUR, label: "Blur", default: 0, min: "0", max: "200", units: "px" },
  { id: BRIGHTNESS, label: "Brightness", default: 100, min: "0", max: "200", units: "%" },
  { id: CONTRAST, label: "Contrast", default: 100, min: "0", max: "200", units: "%" },
  { id: SATURATE, label: "Saturate", default: 100, min: "0", max: "200", units: "%" },
  { id: INVERT, label: "Invert", default: 0, min: "0", max: "100", units: "%" },
];

export const ADVANCED_FILL_DEFAULT_VALUES = Object.fromEntries(
  BACKDROP_FILTER_DEFINITIONS.map((definition) => [definition.id, definition.default])
);

export const ADVANCED_FILL_DEFAULT_BACKDROP_FILTER = fromJS(BACKDROP_FILTER_DEFINITIONS.map((definition) => ({
  [definition.id]: definition.default,
})));

export const BACKDROP_FILTER_CONFIGS = BACKDROP_FILTER_DEFINITIONS.map((definition) => ({
  label: definition.label,
  filterFunctionName: definition.id,
  min: definition.min,
  max: definition.max,
  units: definition.units,
  ...(definition.disabled !== undefined && { disabled: definition.disabled }),
}));

export const ADVANCED_FILL_MODE_PRESETS = {
  darker: {
    color: "#000000:40",
    backdropFilter: [{ blur: 10 }, { brightness: 80 }, { contrast: 120 }, { saturate: 100 }, { invert: 0 }],
  },
  lighter: {
    color: "#ffffff:40",
    backdropFilter: [{ blur: 8 }, { brightness: 120 }, { contrast: 100 }, { saturate: 100 }, { invert: 0 }],
  },
  glassy: {
    color: "#ffffff:20",
    backdropFilter: [{ blur: 15 }, { brightness: 110 }, { contrast: 90 }, { saturate: 80 }, { invert: 0 }],
  },
  "color-tint": {
    color: "#008cff:20",
    backdropFilter: [{ blur: 12 }, { brightness: 100 }, { contrast: 110 }, { saturate: 150 }, { invert: 0 }],
  },
};